<template>
  <sf-form
    v-if="hasLedgerSelected"
    :action="formAction"
    :csrf-token="token"
    :should-submit="loading.submit"
  >
    <input
      id="copy_type"
      type="hidden"
      name="copy_type"
      autocomplete="off"
      :value="copyType"
    />
    <input v-model="selectedLedgerId" name="from_ledger" type="hidden" />
    <input
      v-model="selectedAccountId"
      name="forward_account_id"
      type="hidden"
    />
    <div
      v-for="block in blocksToRender"
      :key="block.key"
      class="sf-below-4"
      :data-behaviour="`spec-adjustments-selective-copy-${block.key}-adjustments`"
      :data-testid="`spec-adjustments-selective-copy-${block.key}-adjustments`"
    >
      <div class="sf-alignc sf-below-2">
        <span class="sf-uppercase">{{ block.title }}</span>
      </div>
      <ContentItem
        v-for="item in block.items"
        :key="item.id"
        v-model="item.checked"
        :item="item"
        :tags="tags"
        @click="toggleAdjustment"
      ></ContentItem>
    </div>
    <div
      v-if="isLedgerDisabled"
      class="sf-alignc sf-c-text-light sf-font-s sf-pad-4 sf-dim-el"
    >
      {{ I18n.t('adjustment.selective_copy.loading') }}
    </div>
  </sf-form>
  <div
    v-else
    class="sf-alignc sf-c-text sf-bg-snow-dark sf-font-l sf-pad-4 sf-dim-el"
  >
    {{ I18n.t('adjustment.selective_copy.select_period_empty_state') }}
  </div>
</template>
<script setup lang="ts">
import { useAdjustmentsStore } from '../store'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import ContentItem from './content-item.vue'
import SfForm from '@app/shared/vue/components/sf-form.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import useCsrfToken from '@app/shared/vue/composables/use-csrf-token'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'AdjustmentsContent',
})

interface Props {
  copyType: 'forward' | 'reverse' | 'normal'
  formAction: string
}

defineProps<Props>()

const I18n = useI18n()

const adjustmentsStore = useAdjustmentsStore()

const {
  hasLedgerSelected,
  isLedgerDisabled,
  loading,
  getExternalAdjustments,
  getExternalPostedAdjustments,
  getInternalAdjustments,
  getInternalPostedAdjustments,
  selectedAccountId,
  selectedLedgerId,
  tags,
} = storeToRefs(adjustmentsStore)

const { toggleAdjustment } = adjustmentsStore

const token = useCsrfToken()

const blocksToRender = computed(() => {
  return [
    {
      key: 'internal',
      title: I18n.t('adjustment.categories.internal'),
      items: getInternalAdjustments.value,
    },
    {
      key: 'external',
      title: I18n.t('adjustment.categories.external'),
      items: getExternalAdjustments.value,
    },
    {
      key: 'internal_posted',
      title: I18n.t('adjustment.categories.internal_posted'),
      items: getInternalPostedAdjustments.value,
    },
    {
      key: 'external_posted',
      title: I18n.t('adjustment.categories.external_posted'),
      items: getExternalPostedAdjustments.value,
    },
  ].filter((block) => block.items.length > 0)
})
</script>
